import { useState } from "react";
import { useShowSnackbar } from "hooks/useShowSnackbar";
import { useCheckoutContext } from "context/checkout-context";
import { capitalizeFirstLetter } from "utils/strings";
import { applyCoupon as applyCouponRequest } from "./requests";

export const useApplyCoupon = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { addNotification, removeNotification } = useShowSnackbar();
  const { device, getCheckoutData, setCouponApplied } = useCheckoutContext();

  const mountCustomError = ({ field, message }) => {
    const formattedFieldText = String(field).replace(/_/g, " ");
    return capitalizeFirstLetter(`${formattedFieldText} ${message}`);
  };

  const handleError = async (error) => {
    const notificationParams = {
      variant: "error",
      message: ""
    };
    const errorResponse = error.response.data.errors;
    if (!!errorResponse) {
      notificationParams.message = mountCustomError(errorResponse[0]);
    } else {
      notificationParams.message = "An error was occurred";
    }

    addNotification(notificationParams);
  };

  const applyCoupon = async ({ promoCode, paymentMethodUUID }) => {
    removeNotification(); // clear snackbar notifications
    try {
      setIsLoading(true);
      await applyCouponRequest({
        promoCode,
        device,
        payment_method_uuid: paymentMethodUUID
      });
      setCouponApplied(promoCode);
      addNotification({
        variant: "success",
        message: `Promo ${promoCode} applied successfully.`
      });
      getCheckoutData();
    } catch (error) {
      handleError(error);
      setCouponApplied("");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    applyCoupon
  };
};
